exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reviewBox{border-width:2px;padding:10px 0px 0px 0px;margin-bottom:5px}.starImages{max-width:25%;max-height:25%;position:relative;display:flex;float:right}.propertyLink{font-size:25px}.card{margin:auto}.card.header{background-color:gray}h6{padding:5px 0px 0px 10px}h1{margin:auto;text-align:center;padding:10px 0px 10px 0px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Reviews/Reviews.scss
// module id = 259
// module chunks = 0